export const technologyMessage = `Which of the following best describes your enterprise’s analytics technology?`;

const technologyQ1 = `Desktop technology, standard office packages, poorly integrated systems`;

const technologyQ2 = `Individual analytical initiatives, statistical packages, descriptive analytics, database 
querying, tabulations`;

const technologyQ3 = `Enterprise analytical plan, tool and platforms; predictive analytical packages`;

const technologyQ4 = `Enterprise analytical plan and process, cloud-based big data`;

const technologyQ5 = `Sophisticated enterprise-wide big data and analytics architecture, cognitive technologies, 
prescriptive and autonomous analytics`;

export const technologyQuestions = [ technologyQ1, technologyQ2, technologyQ3, technologyQ4, technologyQ5 ];
export const technologyQuestionWeight = 0.08;
export const technologyQuestionsScore = [ 0.08, 0.16, 0.24, 0.32, 0.40 ];


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/delta/data/technologyQuestions.ts